export default "__VITE_ASSET__CcIjVSQu__"